export default __webpack_public_path__ + "static/media/11.57658d5b.jpg";